// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W8REpigLcS0uJskQgbd6 {
  width: 100%;
  background: #ffe7c3;
  border-left: 4px solid #ea9500;
  color: #8a5800;
  padding: 12px 18px;
  font-size: 1.05em;
  border-radius: 6px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.PUFuMRTUPmqotkP6Tryu {
  width: min(800px, 70vw);
  min-width: 330px;
  margin: 40px auto 60px;
  background: var(--dst-surface);
  color: var(--dst-text);
  border-radius: 18px;
  box-shadow: 0 2px 22px rgba(0, 0, 0, 0.1);
  padding: 32px 28px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 950px) {
  .PUFuMRTUPmqotkP6Tryu {
    width: 95vw;
    max-width: 97vw;
    padding: 18px 5vw;
  }
}

.YrfSTDb9Y726ygq5KnQn {
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.BHCj3LTFDYHocZFeizGQ {
  min-width: 0;
}

.P_uH8JfCDAB8LkHyxveC {
  display: flex;
  align-items: center;
  gap: 8px;
}

.e2gXCvV4oK6EZGDn71wa {
  flex-shrink: 0;
  background: var(--dst-card-bg);
  border: 1px solid var(--dst-border);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.85em;
  color: var(--dst-text);
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.13s, color 0.13s;
  touch-action: manipulation;
}

.e2gXCvV4oK6EZGDn71wa:hover {
  background: var(--dst-info-bg);
  color: var(--dst-info-text);
}

.e2gXCvV4oK6EZGDn71wa:focus-visible {
  outline: var(--dst-focus);
  outline-offset: 2px;
}

.SlKpU47C0Wac9cqVORZg {
  flex-shrink: 0;
  display: inline-block;
  background: #b42318;
  border: 1px solid #b42318;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.85em;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.13s, border-color 0.13s;
}

.SlKpU47C0Wac9cqVORZg:hover {
  background: #912018;
  border-color: #912018;
}

.SlKpU47C0Wac9cqVORZg:focus-visible {
  outline: var(--dst-focus);
  outline-offset: 2px;
}

.j3NxyLTYAQG6yQuYSl35 {
  font-size: 2.3em;
  font-weight: 700;
  color: var(--dst-primary-strong, #1741a8);
  margin: 0;
  font-family: 'Segoe UI', Arial, sans-serif;
}

.E5g9N7MsmiThpzuCIVBm {
  margin: 6px 0 0;
  font-size: 0.95em;
  font-weight: 600;
  color: var(--dst-muted);
}

.vdDQCDvgCRNOTBmonCIF {
  display: flex;
  flex-wrap: nowrap;
  gap: 2px;
  justify-content: flex-start;
  width: 100%;
  border-bottom: 2px solid var(--dst-border);
  margin-bottom: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.lOLMgSxUIVpoVX107NGd {
  flex: 0 0 auto;
  white-space: nowrap;
  min-height: 44px;
  padding: 12px 18px 10px;
  font-size: 1.08em;
  font-weight: 500;
  color: var(--dst-text);
  background: var(--dst-card-bg);
  border: 1px solid var(--dst-border);
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  margin-right: 2px;
  margin-bottom: -2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  cursor: pointer;
  touch-action: manipulation;
  transition: background 0.12s, color 0.12s;
}

.lOLMgSxUIVpoVX107NGd:focus-visible {
  outline: 3px solid rgba(32, 94, 200, 0.45);
  outline-offset: 1px;
}

.lOLMgSxUIVpoVX107NGd:hover:not(.RPlCRC79xH83PW_ze223) {
  background: var(--dst-info-bg);
  color: var(--dst-info-text);
}

.lOLMgSxUIVpoVX107NGd.RPlCRC79xH83PW_ze223 {
  background: var(--dst-surface);
  color: var(--dst-primary);
  font-weight: 600;
  border-bottom: 2px solid var(--dst-surface);
  box-shadow: 0 -2px 12px rgba(32, 94, 200, 0.06) inset;
  z-index: 3;
}

.STxP1KHmWZWpWQM5tAHR {
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 800px) {
  .PUFuMRTUPmqotkP6Tryu {
    padding: 16px;
  }

  .lOLMgSxUIVpoVX107NGd {
    min-height: 42px;
    padding: 9px 10px;
    font-size: 0.98em;
  }

  .j3NxyLTYAQG6yQuYSl35 {
    font-size: 1.6em;
    margin-bottom: 12px;
  }
}

@media (max-width: 600px) {
  .PUFuMRTUPmqotkP6Tryu {
    padding: 12px;
    margin: 10px auto;
  }

  .j3NxyLTYAQG6yQuYSl35 {
    font-size: 1.4em;
    margin-bottom: 10px;
  }

  .lOLMgSxUIVpoVX107NGd {
    min-height: 40px;
    padding: 8px 12px;
    font-size: 0.85em;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/components/OfficerDashboard/OfficerDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,qDAAqD;EACrD,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".warningBanner {\n  width: 100%;\n  background: #ffe7c3;\n  border-left: 4px solid #ea9500;\n  color: #8a5800;\n  padding: 12px 18px;\n  font-size: 1.05em;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  box-sizing: border-box;\n}\n\n.container {\n  width: min(800px, 70vw);\n  min-width: 330px;\n  margin: 40px auto 60px;\n  background: var(--dst-surface);\n  color: var(--dst-text);\n  border-radius: 18px;\n  box-shadow: 0 2px 22px rgba(0, 0, 0, 0.1);\n  padding: 32px 28px 24px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n@media (max-width: 950px) {\n  .container {\n    width: 95vw;\n    max-width: 97vw;\n    padding: 18px 5vw;\n  }\n}\n\n.header {\n  width: 100%;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.headerText {\n  min-width: 0;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.themeToggle {\n  flex-shrink: 0;\n  background: var(--dst-card-bg);\n  border: 1px solid var(--dst-border);\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 0.85em;\n  color: var(--dst-text);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.13s, color 0.13s;\n  touch-action: manipulation;\n}\n\n.themeToggle:hover {\n  background: var(--dst-info-bg);\n  color: var(--dst-info-text);\n}\n\n.themeToggle:focus-visible {\n  outline: var(--dst-focus);\n  outline-offset: 2px;\n}\n\n.logoutButton {\n  flex-shrink: 0;\n  display: inline-block;\n  background: #b42318;\n  border: 1px solid #b42318;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 0.85em;\n  color: #fff;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.13s, border-color 0.13s;\n}\n\n.logoutButton:hover {\n  background: #912018;\n  border-color: #912018;\n}\n\n.logoutButton:focus-visible {\n  outline: var(--dst-focus);\n  outline-offset: 2px;\n}\n\n.title {\n  font-size: 2.3em;\n  font-weight: 700;\n  color: var(--dst-primary-strong, #1741a8);\n  margin: 0;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n\n.subtitle {\n  margin: 6px 0 0;\n  font-size: 0.95em;\n  font-weight: 600;\n  color: var(--dst-muted);\n}\n\n.tabs {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 2px;\n  justify-content: flex-start;\n  width: 100%;\n  border-bottom: 2px solid var(--dst-border);\n  margin-bottom: 24px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.tab {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  min-height: 44px;\n  padding: 12px 18px 10px;\n  font-size: 1.08em;\n  font-weight: 500;\n  color: var(--dst-text);\n  background: var(--dst-card-bg);\n  border: 1px solid var(--dst-border);\n  border-bottom: none;\n  border-radius: 10px 10px 0 0;\n  margin-right: 2px;\n  margin-bottom: -2px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);\n  cursor: pointer;\n  touch-action: manipulation;\n  transition: background 0.12s, color 0.12s;\n}\n\n.tab:focus-visible {\n  outline: 3px solid rgba(32, 94, 200, 0.45);\n  outline-offset: 1px;\n}\n\n.tab:hover:not(.active) {\n  background: var(--dst-info-bg);\n  color: var(--dst-info-text);\n}\n\n.tab.active {\n  background: var(--dst-surface);\n  color: var(--dst-primary);\n  font-weight: 600;\n  border-bottom: 2px solid var(--dst-surface);\n  box-shadow: 0 -2px 12px rgba(32, 94, 200, 0.06) inset;\n  z-index: 3;\n}\n\n.tabContent {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 800px) {\n  .container {\n    padding: 16px;\n  }\n\n  .tab {\n    min-height: 42px;\n    padding: 9px 10px;\n    font-size: 0.98em;\n  }\n\n  .title {\n    font-size: 1.6em;\n    margin-bottom: 12px;\n  }\n}\n\n@media (max-width: 600px) {\n  .container {\n    padding: 12px;\n    margin: 10px auto;\n  }\n\n  .title {\n    font-size: 1.4em;\n    margin-bottom: 10px;\n  }\n\n  .tab {\n    min-height: 40px;\n    padding: 8px 12px;\n    font-size: 0.85em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningBanner": `W8REpigLcS0uJskQgbd6`,
	"container": `PUFuMRTUPmqotkP6Tryu`,
	"header": `YrfSTDb9Y726ygq5KnQn`,
	"headerText": `BHCj3LTFDYHocZFeizGQ`,
	"headerActions": `P_uH8JfCDAB8LkHyxveC`,
	"themeToggle": `e2gXCvV4oK6EZGDn71wa`,
	"logoutButton": `SlKpU47C0Wac9cqVORZg`,
	"title": `j3NxyLTYAQG6yQuYSl35`,
	"subtitle": `E5g9N7MsmiThpzuCIVBm`,
	"tabs": `vdDQCDvgCRNOTBmonCIF`,
	"tab": `lOLMgSxUIVpoVX107NGd`,
	"active": `RPlCRC79xH83PW_ze223`,
	"tabContent": `STxP1KHmWZWpWQM5tAHR`
};
export default ___CSS_LOADER_EXPORT___;
